
define('text!templates/modules/feedback/blocks/feeling.html',[],function () { return '<div id="feedback-feeling"></div>\n';});

